import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useHistory } from 'react-router-dom'

const useComponent = () => {
  const { theme } = useCustomTheme()
  const { skipUploadCertificate, user, updateUser } = useAuth()

  const history = useHistory()

  const handleEnter = () => {
    // skipUploadCertificate()
    if (!user) return
    updateUser({ ...user, emailIsConfirmed: true })
    history.push('/dashboard')
    // history.push('/request-permission')
  }

  const handleBack = () => {
    history.push('/datasource-connect')
  }

  return {
    theme,
    handleEnter,
    handleBack,
  }
}

export default useComponent
